/*
 * Business details used by the Terms of Service and Privacy Policy (and the landing footer / emails).
 * Supplied by the owner (WannaWare, Spokane Valley WA). `isPlaceholder()` flags anything still containing "your-" or "[".
 */
export const LEGAL = {
  brand: 'WannaPublish',
  operator: 'WannaWare', // the legal entity that sells the subscription (what customers see on Stripe)
  operatorAddress: 'Spokane Valley, Washington, USA', // shown in the policies (add a street address if you want one there)
  contactEmail: 'info@wannaware.com', // where billing / privacy / support questions go
  jurisdiction: 'the State of Washington, United States', // governing law for the Terms
  lastUpdated: '1 October 2026',
  // pricing — keep in step with backend/billing.py PLANS
  monthlyPrice: '$4.99',
  annualPrice: '$50',
  currency: 'US dollars',
  trialDays: 14,
  refundWindowDays: 14, // "something went wrong" refund window after a charge
  trashDays: 30,
};

export const isPlaceholder = (value) => !value || /your-|\[/.test(String(value));
